import * as yup from 'yup';
import { emailField } from './common';

export const forgotPasswordFormSchema = yup.object({
  email: emailField,
});
